export const GetWindRoseChartData = "GetWindRoseChartData";
export const GetWindRoseChartDataSuccess = "GetWindRoseChartDataSuccess";
export const GetWindRoseChartDataError = "GetWindRoseChartDataError";
